export const styles = {
  container: {
    width: '100%',
    maxWidth: '100%',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '24px',
    boxSizing: 'border-box' as const
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    backgroundColor: 'var(--card-bg)',
    borderRadius: '12px',
    border: '1px solid var(--border-color)',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
  },
  logoGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  badge: {
    padding: '4px 8px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: 'bold',
    backgroundColor: 'var(--accent)',
    color: '#fff',
    letterSpacing: '0.05em'
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: 'var(--text-main)'
  },
  healthStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px'
  },
  dot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%'
  },
  statusText: {
    color: 'var(--text-muted)'
  },
  urlInput: {
    padding: '6px 12px',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    backgroundColor: 'var(--bg-color)',
    color: 'var(--text-main)',
    fontFamily: 'monospace',
    fontSize: '12px',
    width: '320px',
    marginLeft: '8px',
    outline: 'none',
    transition: 'border-color 0.2s'
  },
  mainGrid: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '24px'
  },
  card: {
    backgroundColor: 'var(--card-bg)',
    borderRadius: '12px',
    border: '1px solid var(--border-color)',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '16px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.3)'
  },
  sectionHeader: {
    fontSize: '18px',
    fontWeight: 600,
    color: 'var(--text-main)',
    borderBottom: '1px solid var(--border-color)',
    paddingBottom: '12px',
    marginBottom: '4px'
  },
  subHeader: {
    fontSize: '14px',
    fontWeight: 600,
    color: 'var(--text-main)',
    marginBottom: '10px',
    letterSpacing: '0.03em',
    textTransform: 'uppercase' as const
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '8px'
  },
  row: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap' as const
  },
  col: {
    flex: 1,
    minWidth: '150px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '6px'
  },
  fieldLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: 'var(--text-muted)',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em'
  },
  numberLabel: {
    fontSize: '11px',
    color: 'var(--text-muted)'
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '8px'
  },
  input: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    backgroundColor: 'var(--bg-color)',
    color: 'var(--text-main)',
    fontSize: '14px',
    outline: 'none'
  },
  textarea: {
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    backgroundColor: 'var(--bg-color)',
    color: 'var(--text-main)',
    fontSize: '14px',
    outline: 'none',
    resize: 'vertical' as const,
    fontFamily: 'inherit'
  },
  checkboxContainer: {
    display: 'flex',
    flexDirection: 'row' as const,
    gap: '24px',
    padding: '4px 0',
    flexWrap: 'wrap' as const
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    cursor: 'pointer'
  },
  checkbox: {
    cursor: 'pointer'
  },
  primaryButton: {
    padding: '12px 24px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: 'var(--accent)',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    outline: 'none'
  },
  errorAlert: {
    padding: '12px',
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    border: '1px solid rgba(239, 68, 68, 0.3)',
    color: '#fca5a5',
    borderRadius: '6px',
    fontSize: '13px'
  },
  canvasContainer: {
    position: 'relative' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'var(--bg-color)',
    borderRadius: '8px',
    padding: '16px',
    border: '1px solid var(--border-color)',
    minHeight: '500px',
    overflow: 'hidden' as const,
    cursor: 'grab' as const
  },
  canvasContainerDragging: {
    cursor: 'grabbing' as const
  },
  svg: {
    display: 'block',
    userSelect: 'none' as const
  },
  coordinatesList: {
    marginTop: '8px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    fontSize: '13px'
  },
  th: {
    textAlign: 'left' as const,
    padding: '10px 8px',
    borderBottom: '2px solid var(--border-color)',
    color: 'var(--text-muted)',
    fontWeight: 600
  },
  tr: {
    borderBottom: '1px solid var(--border-color)'
  },
  td: {
    padding: '10px 8px',
    color: 'var(--text-main)'
  },
  code: {
    fontFamily: 'monospace',
    color: '#ab47bc',
    backgroundColor: 'rgba(171, 71, 188, 0.1)',
    padding: '2px 4px',
    borderRadius: '4px'
  },
  typeSpan: {
    color: 'var(--text-muted)',
    fontSize: '11px'
  },
  logsSplitGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    width: '100%'
  },
  logBox: {
    backgroundColor: 'var(--bg-color)',
    border: '1px solid var(--border-color)',
    borderRadius: '8px',
    padding: '16px',
    maxHeight: '320px',
    overflowY: 'auto' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px'
  },
  emptyLogs: {
    color: 'var(--text-muted)',
    fontSize: '13px',
    textAlign: 'center' as const,
    padding: '40px 0'
  },
  logItem: {
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    paddingBottom: '10px'
  },
  logMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px'
  },
  logBadge: {
    fontSize: '9px',
    fontWeight: 'bold',
    padding: '2px 6px',
    borderRadius: '4px',
    color: '#fff'
  },
  logTime: {
    fontSize: '10px',
    color: 'var(--text-muted)'
  },
  logText: {
    fontSize: '12px',
    color: 'var(--text-main)',
    lineHeight: '1.4'
  },
  details: {
    marginTop: '6px'
  },
  summary: {
    fontSize: '11px',
    color: 'var(--accent)',
    cursor: 'pointer',
    outline: 'none'
  },
  json: {
    marginTop: '6px',
    fontSize: '10px',
    backgroundColor: 'rgba(0,0,0,0.3)',
    padding: '8px',
    borderRadius: '4px',
    overflowX: 'auto' as const,
    fontFamily: 'JetBrains Mono, monospace',
    color: '#34d399'
  },
  codeBox: {
    backgroundColor: 'var(--bg-color)',
    border: '1px solid var(--border-color)',
    borderRadius: '8px',
    padding: '16px',
    maxHeight: '320px',
    overflowY: 'auto' as const
  },
  scriptPre: {
    margin: 0,
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '12px'
  },
  python: {
    color: '#ab47bc'
  },
  emptyScript: {
    color: 'var(--text-muted)',
    fontSize: '13px',
    textAlign: 'center' as const,
    padding: '40px 0'
  },
  validationSection: {
    marginTop: '8px',
    paddingTop: '8px'
  },
  validationSummaryGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '12px',
    marginBottom: '16px'
  },
  validationCard: {
    backgroundColor: 'rgba(255,255,255,0.02)',
    border: '1px solid var(--border-color)',
    borderRadius: '8px',
    padding: '12px',
    textAlign: 'center' as const
  },
  valNumber: {
    fontSize: '22px',
    fontWeight: 'bold',
    color: 'var(--text-main)'
  },
  valLabel: {
    fontSize: '11px',
    color: 'var(--text-muted)',
    marginTop: '2px',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em'
  },
  rulesList: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '10px'
  },
  ruleItem: {
    backgroundColor: 'rgba(255,255,255,0.01)',
    border: '1px solid var(--border-color)',
    borderRadius: '6px',
    padding: '12px'
  },
  ruleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px'
  },
  ruleId: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: 'var(--text-main)',
    fontFamily: 'monospace'
  },
  statusBadge: {
    fontSize: '10px',
    fontWeight: 'bold',
    padding: '2px 6px',
    borderRadius: '4px'
  },
  ruleMsg: {
    fontSize: '12px',
    color: 'var(--text-muted)',
    lineHeight: '1.4'
  },
  repairInfo: {
    marginTop: '6px',
    fontSize: '11px',
    color: '#fca5a5',
    backgroundColor: 'rgba(239, 68, 68, 0.05)',
    padding: '6px 10px',
    borderRadius: '4px',
    borderLeft: '2px solid #ef4444',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '12px',
    flexWrap: 'wrap' as const
  },
  select: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    backgroundColor: 'var(--bg-color)',
    color: 'var(--text-main)',
    fontSize: '14px',
    outline: 'none',
    width: '100%',
    cursor: 'pointer'
  },
  saveButton: {
    padding: '12px 24px',
    borderRadius: '6px',
    border: 'none',
    backgroundColor: '#2e7d32',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    outline: 'none'
  },

  // NEW STYLES:
  fileUploadRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '16px',
    border: '2px dashed var(--border-color)',
    borderRadius: '8px',
    backgroundColor: 'rgba(255,255,255,0.01)',
    transition: 'all 0.2s ease',
    width: '100%'
  },
  fileUploadBtn: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    backgroundColor: 'var(--bg-color)',
    color: 'var(--text-main)',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500,
    outline: 'none'
  },
  fileUploadText: {
    fontSize: '13px',
    color: 'var(--text-muted)'
  },
  accordion: {
    border: '1px solid var(--border-color)',
    borderRadius: '8px',
    overflow: 'hidden',
    marginTop: '16px',
    backgroundColor: 'rgba(255,255,255,0.01)'
  },
  accordionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 20px',
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
    cursor: 'pointer',
    userSelect: 'none' as const,
    transition: 'background-color 0.2s'
  },
  accordionTitle: {
    fontSize: '15px',
    fontWeight: 600,
    color: 'var(--text-main)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  accordionArrow: {
    fontSize: '12px',
    color: 'var(--text-muted)',
    transition: 'transform 0.2s ease'
  },
  accordionContent: {
    padding: '20px',
    backgroundColor: 'transparent',
    borderTop: '1px solid var(--border-color)'
  },
  solveBtn: {
    padding: '4px 10px',
    borderRadius: '4px',
    border: '1px solid #ef4444',
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    color: '#fca5a5',
    cursor: 'pointer',
    fontSize: '11px',
    fontWeight: 600,
    transition: 'all 0.2s',
    outline: 'none'
  },
  solveAllBtn: {
    padding: '10px 16px',
    borderRadius: '6px',
    border: '1px solid #ef4444',
    backgroundColor: 'rgba(239, 68, 68, 0.15)',
    color: '#fca5a5',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: 600,
    transition: 'all 0.2s',
    outline: 'none',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    marginTop: '4px',
    boxSizing: 'border-box' as const
  },
  canvasControls: {
    position: 'absolute' as const,
    bottom: '16px',
    right: '16px',
    display: 'flex',
    gap: '8px',
    zIndex: 10
  },
  canvasBtn: {
    width: '36px',
    height: '36px',
    borderRadius: '6px',
    border: '1px solid var(--border-color)',
    backgroundColor: 'var(--card-bg)',
    color: 'var(--text-main)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '16px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
    userSelect: 'none' as const,
    outline: 'none',
    transition: 'all 0.2s'
  },
  geminiPromptsBox: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '12px',
    marginTop: '16px',
    padding: '16px',
    backgroundColor: 'rgba(255, 255, 255, 0.02)',
    borderRadius: '8px',
    border: '1px solid var(--border-color)'
  },
  geminiCallCard: {
    backgroundColor: 'var(--bg-color)',
    border: '1px solid var(--border-color)',
    borderRadius: '6px',
    padding: '14px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '10px'
  },
  preWrap: {
    margin: 0,
    whiteSpace: 'pre-wrap' as const,
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '12px',
    color: 'var(--text-main)',
    backgroundColor: 'rgba(0,0,0,0.2)',
    padding: '10px',
    borderRadius: '4px',
    overflowX: 'auto' as const
  },
  sideBySideContainer: {
    display: 'flex',
    gap: '24px',
    flexWrap: 'wrap' as const,
    width: '100%',
    alignItems: 'stretch'
  },
  leftColumn: {
    flex: '1 1 600px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '16px',
    minWidth: '320px'
  },
  rightColumn: {
    flex: '1 1 400px',
    display: 'flex',
    flexDirection: 'column' as const,
    gap: '16px',
    minWidth: '320px'
  }
};
